import styled from "styled-components";

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  padding-bottom: 10px;
`;

export const Title = styled.h2`
  color: #00aeea;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  padding-left: 10px;
  justify-self: auto;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  margin-right: 10px;
  margin-top: 5px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
  font-weight: normal;
  margin-bottom:  ${(props) => props.marginBottom ?? "10px"};
}
`;

export const PaddingDiv = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;

export const NoContact = styled.span`
  font-family: Lato;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: left;
  color: #cccccc;
`;
